const DATA_TYPES = {
    是否型: "是否型",
    選項型: "選項型",
    數值型級距: "數值型(級距)",
    數值型單數: "數值型(單數)",
    條列型: "條列型",
};

export const ALL_CHART_TYPES = {
    BAR: "bar",
    STACK_BAR: "stackBar",
    GROUPED_BAR: "groupedBar",
    PIE: "pie",
    LINE: "line",
    HEATMAP: "heatmap",
    MOSAIC: "mosaic",
    MULTIPLE_LINE: "multipleLine",
};
export default DATA_TYPES;